export default "__VITE_ASSET__A0J5L50w__"